<template>
	<div>
		<!-- <iframe id="myFrame" scrolling="no" frameborder="0" :src="urlImg2" v-if="isShowIframe" style="width:22vw;height:35vw;position: fixed;bottom: 20px;right: 160px;z-index: 99999;box-shadow: 0 0 20px #ccc"></iframe> -->
    <div class="service-wrap">
      <div class="openService" @mouseenter="handleIn" @mouseleave="handleLeave">
        <img :src="urlImg" id="openService" @click="openService" />
      </div>
      <transition name="service-popver">
        <div class="contentDiv" :class="[lang]" v-show="serveTipsShow">
          <div>{{ lang === 'en-us' ? 'If you have any operational questions,' : '操作流程有疑问？' }}</div>
          <div>{{ lang === 'en-us' ? 'please use intelligent customer service.' : '点击咨询客服吧！' }}</div>
        </div>
      </transition>
    </div>
		<div class="fixedBtn">
			<!-- <div class="CnorEn" @click="CNorENClick()">
            <img v-show="$store.state.i18n" src="@/images/english/i18n_en.png" />
            <img v-show="!$store.state.i18n" src="@/images/english/i18n_zh.png" />
        </div> -->
			<div class="service" @click="backShow = !backShow">
				<img src="@/images/home/1-29.png" />
			</div>
			<div class="backTop" @click="backTop()">
				<img src="@/images/home/1-28.png" />
			</div>
			<div class="backShow" v-show="backShow">
				<div class="title">{{$store.state.i18n?componentsLang.pc.chinese.backTop.tel:componentsLang.pc.english.backTop.tel}}</div>
				<div>4008040080</div>
				<div class="title">{{$store.state.i18n?componentsLang.pc.chinese.backTop.email:componentsLang.pc.english.backTop.email}}</div>
				<div>jdh@jdh.com.cn</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				backShow: false,
				urlImg: '../../static/robot.gif',
				iframeUrl: '',
				urlImg2: '',
				isShowIframe: false,
				lang: 'zh-cn',
        isSdkReady: false,
        dialog: null,
        serveTipsShow: false,
        openTimer: null,
        closeTimer: null
			}
		},
		mounted() {
		},
		created() {
			if (this.$store.state.i18n) {
				this.lang = "zh-cn"
			} else {
				this.lang = "en-us"
			}
			if (this.lang == "zh-cn") {
				let src = 'robot.gif'
				this.urlImg = require("../../static/" + src)
			} else if (this.lang == "en-us") {
				let src = 'robot.gif'
				this.urlImg = require("../../static/" + src)
			}

		},
  methods: {
    sdkInit () {
      if (window.JsSdk) {
        this.dialog = window.JsSdk.init({
          url: 'https://u-tcltcl.dezhuyun.com/dzfront/web/home?token=IB3qayIZBfEb&side=mobile',
          http: {
            // 服务器地址（必须）
            root: 'https://u-tcltcl.dezhuyun.com',
            // 请求参数
            data: {
              LOCAL_TOKEN: 'IB3qayIZBfEb'
            }
          },
          frame: {
            screen: 'center',
            pageTitle: '系统默认渠道', // 网页标题
            title: '管理员', // 提示
            layer: {
              width: '375px', // 浮层打开时的宽度
              height: '600px', // 浮层打开时的高度
              zIndex: 3000
            }
          },
          toolbar: {
            visible: false
          }
        })
      }
    },
		// 返回顶部
		backTop() {
			let top = document.documentElement.scrollTop || document.body.scrollTop;
			// 实现滚动效果 
			const timeTop = setInterval(() => {
				document.body.scrollTop = document.documentElement.scrollTop = top -= 50;
				if (top <= 0) {
					clearInterval(timeTop);
				}
			}, 10);
		},
		// 中英文切换
		CNorENClick() {
			this.$emit('loadingShowClick', true);
			setTimeout(() => {
				this.$store.commit('setI18n');
				this.$router.go(0);
			}, 1500)
		},
    openService () {
      if (!this.dialog) this.sdkInit()
      this.$nextTick(() => {
        if (this.dialog) {
          this.dialog.open()
        }
      })
    },
    handleIn () {
      this.clearTimers()

      this.openTimer = setTimeout(() => {
        this.serveTipsShow = true
      }, 200)
    },
    handleLeave () {
      this.clearTimers()

      this.closeTimer = setTimeout(() => {
        this.serveTipsShow = false
      }, 200)
    },
    clearTimers () {
      clearTimeout(this.openTimer)
      clearTimeout(this.closeTimer)
      this.openTimer = null
      this.closeTimer = null
    }
  }
}
</script>
<style scoped>
	* {
		margin: 0;
		padding: 0;
		box-sizing: border-box;
	}


	.backShow {
		width: 22.813vw;
		height: 20.146vw;
		background-image: url('../../images/home/1-48.png');
		background-size: 100% 100%;
		position: absolute;
		top: -7.05vw;
		left: -10.417vw;
		display: flex;
		align-items: center;
		justify-content: center;
		flex-direction: column;
		padding-right: 2.083vw;
		letter-spacing: 0.104vw;
		transform: scale(0.5) translateX(-50%);
	}

	.backShow>div:nth-child(even) {
		color: #c31618;
		margin: 0.417vw 0 2.5vw;
		font-weight: bolder;
	}

	.backShow>div {
		font-size: 1.875vw;
	}

	.backShow .title {
		font-size: 2.2vw;
		font-weight: bold;
	}





	/* 联系客服 or  返回顶部 */
	.fixedBtn {
		/* transform: scale(0.9); */
		/* width:3.5154vw;height:9.492795vw; */
		width: 3.5154vw;
		height: 7.0308vw;
		position: fixed;
		right: 5.208vw;
		top: 31.25vw;
		z-index: 999;
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		border: 0.052vw solid #859199;
		box-sizing: border-box;
		cursor: pointer;
	}

	.fixedBtn .CnorEn {
		width: 100%;
		flex: 1;
		display: flex;
		justify-content: center;
		align-items: center;
		position: relative;
		background-color: white;
	}

	.fixedBtn .service {
		width: 100%;
		flex: 1;
		display: flex;
		justify-content: center;
		align-items: center;
		position: relative;
		background-color: #c6151d;
	}

	.fixedBtn .backTop {
		width: 100%;
		flex: 1;
		display: flex;
		justify-content: center;
		align-items: center;
		position: relative;
		background-color: white;
	}

	.fixedBtn .CnorEn img {
		width: 1.94076vw;
		height: 2.016vw;
		transition: .3s;
	}

	.fixedBtn .service img {
		width: 1.94076vw;
		height: 2.016vw;
		transition: .3s;
	}

	.fixedBtn .backTop img {
		width: 1.94076vw;
		height: 2.016vw;
		transition: .3s;
	}

	.fixedBtn .CnorEn:hover img,
	.fixedBtn .service:hover img,
	.fixedBtn .backTop:hover img {
		transform: scale(1.3);
	}

	.openService {
		width: 3.5154vw;
		height: 3.5154vw;
		cursor: pointer;
    background-image: url('../../static/serviceBg.png');
    background-size: 100%;
	}

	.openService img {
		width: 100%;
		height: 100%;
	}

  .service-wrap {
    position: fixed;
		right: 5.208vw;
		top: 27.00vw;
		z-index: 2000;
  }

  .contentDiv {
    position: absolute;
    right: 3.675vw;
    top: 50%;
    transform: translateY(-50%);
    width: 8.177vw;
    min-width: 124.03px;
    height: 4.01vw;
    min-height: 60.83px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    font-size: 0.729vw;
    text-align: center;
    color: #ff4d4f;
    background-image: url('../../static/intelBg.png');
    background-size: 100%;
  }
  .contentDiv.en-us {
    width: 15.989vw;
    min-width: 248.3px;
    background-image: url('../../static/intelBg_en.png');
  }
  .service-popver-enter-active {
    transition: opacity 0.15s ease-out;
  }
  .service-popver-leave-active {
    transition: opacity 0.1s ease-in;
  }
  .service-popver-enter,.service-popver-leave-to {
    opacity: 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/backTop/index.vue